<template lang="pug">
.yc-select
  v-select(hide-details :label="label" :placeholder="placeholder" :items="items" filled :item-text="itemText" :item-value="itemValue" v-model="modelValue" auto :menu-props="{ bottom: true, offsetY: true, nudgeBottom: 8, rounded: 'lg' }" :dense="dense" height="48")
    template(v-slot:append)
      v-icon.mt-1 $yzi-chevron-down
    template(v-slot:no-data)
      .text-sm.px-6.py-2 {{ noDataText }}
    template(v-slot:item="{ item }")
      .py-3.text-sm {{ item[itemText] }}
</template>

<script>
export default {
  props: {
    label: {
      default: null
    },
    placeholder: {
      default: null
    },
    items: {
      default: undefined
    },
    value: {
      default: undefined
    },
    dense: {
      default: false
    },
    noDataText: {
      default: null
    },
    itemText: {
      default: 'label'
    },
    itemValue: {
      default: 'id'
    }
  },
  computed: {
    modelValue: {
      get () {
        return this.value
      },
      set (newValue) {
        this.$emit('input', newValue)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .v-select {
    border-radius: 10px;
    font-size: 16px !important;
    color: #333;

    ::placeholder {
      color: #848484 !important;
    }
    .v-select__selections {      
      .v-select__selection {
        color: #333;
        caret-color: #333;
        font-size: 16px !important;
        margin-left: 4px;
      }
    }
    .v-input__slot {
      background: #FFF !important;
      border: 1px solid #c1c1c1 !important;
    }

    .v-label--active {
      margin-top: -2px !important;
    }

    label {
      font-size: 16px !important;
      margin-top: 0px !important;
      margin-left: 4px !important;
      font-weight: unset !important;
      color: #848484 !important;
    }

    input {
      cursor: pointer !important;
    }

    .v-input__slot:before, 
    .v-input__slot:after {
      border: none !important;
    }
    .v-label {
      color: #848484;
    }
  }
}
</style>